const getApiUrl = (origin, useLoadBalancer = typeof window === 'undefined') => {
  const production = !/local|review|qa/.test(origin);

  if (useLoadBalancer) {
    if (!production && process.env.API_QA_LB_SERVICE_HOST) {
      return `http://${process.env.API_QA_LB_SERVICE_HOST}:${
        process.env.API_QA_LB_SERVICE_PORT}/graphql/`;
    }

    if (process.env.API_PRODUCTION_LB_SERVICE_HOST) {
      return `http://${process.env.API_PRODUCTION_LB_SERVICE_HOST}:${
        process.env.API_PRODUCTION_LB_SERVICE_PORT}/graphql/`;
    }
  }

  const environmentApiUrl = process.env.NEXT_PUBLIC_API_URL;
  if (environmentApiUrl) {
    return environmentApiUrl;
  }

  if (production) {
    return 'https://api.fashionunited.com/graphql/';
  }

  return 'https://qa-api.fashionunited.com/graphql/';
};

export default getApiUrl;
